<!-- =========================================================================================
  File Name: Alert.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <alert-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @getdata="getdata"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <!-- <div>
      <vs-button class="user_add_btn" type="filled" @click="addNewData"
        ><feather-icon
          icon="PlusIcon"
          class="flex-inline"
          svgClasses="h-3 w-3"
        />
        New Alert</vs-button
      >
    </div> -->
    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="data"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                data.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : data.length
              }}
              of {{ queriedCamUsers }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Sender</vs-th>
        <vs-th>Message</vs-th>
        <vs-th>Log</vs-th>
        <vs-th>Date</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.sender.fname }} {{ tr.sender.lname }}
              </p>
            </vs-td>

            <vs-td>
              <p
                class="product-name font-medium truncate"
                @click="ViewMessage(tr.message)"
              >
                {{ tr.message }}
              </p>
            </vs-td>
            <vs-td>
              <vs-chip v-if="tr.alert_user.length > 0"
                ><span @click="Viewdata(tr.alert_user)">Review SMS Log</span></vs-chip
              >
              <vs-chip v-if="tr.alert_student.length > 0"
                ><span @click="ViewStudentdata(tr.alert_student)"
                  >Review Message Log</span
                ></vs-chip
              >
              <vs-chip v-if="tr.alert_program.length > 0"
                ><span @click="ViewProgramdata(tr.alert_program)"
                  >Review Program Log</span
                ></vs-chip
              >
              <!-- <span v-for="(user, index) in tr.alert_user" :key="index"> -->
              <!-- <vs-chip> <span class="flex items-center">
                  <div v-if="user.status==='Success'" class="h-2 w-2 rounded-full mr-1 bg-success" ></div>
                  <div v-else class="h-2 w-2 rounded-full mr-1 bg-danger"></div>
                  <span >{{user.phone}}</span>
            </span></vs-chip> -->
              <!-- </span> -->
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.created_at | formatDates }}
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-popup class="holamundo" title=" " :active.sync="popupProgramView">
      <table style="width: 100%">
        <tr>
          <th>Color</th>
          <th>Program</th>
          <th>Status</th>
        </tr>

        <tr v-for="(program, index) in ProgramView" :key="index">
          <td><vs-chip :color="program.program_id.color_code"> </vs-chip></td>
          <td>{{ program.program_id.name }}</td>
          <td>{{ program.status }}</td>
        </tr>
      </table>
    </vs-popup>
    <vs-popup class="holamundo" title=" "  :active.sync="popupStudentView">
      <table style="width: 100%">
        <tr>
          <th></th>
          <th>Student</th>
          <th>Status</th>
        </tr>

        <tr v-for="(student, index) in StudentView" :key="index">
          <!-- <td>   <vs-chip> -->

          <vs-avatar
            v-if="student.student_id.image"
            :src="img_cdn + student.student_id.image"
            size="40px"
          />
          <vs-avatar v-else size="40px" />
          <!-- Avatar Image -->
          <!-- </vs-chip></td> -->
           <td class="font-medium truncate product-name" style="width: 150px;">{{ student.student_id.fname }} {{ student.student_id.lname }}</td>
          <td class="font-medium truncate product-name">{{ student.status }}</td>
        </tr>
      </table>
    </vs-popup>
    <vs-popup class="holamundo" title=" " :active.sync="popupView">
      <table style="width: 100%">
        <tr>
          <th>User</th>
          <th>Phone</th>
          <th>Status</th>
        </tr>

        <tr v-for="(user, index) in UserView" :key="index">
          <td>{{ user.user_id.fname }} {{ user.user_id.lname }}</td>
          <td>{{ user.phone }}</td>
          <td>{{ user.status }}</td>
        </tr>
      </table>
    </vs-popup>
    <vs-popup class="holamundo" title=" " :active.sync="MsgpopupView">
      <p>{{ MsgView }}</p>
    </vs-popup>
    <vs-popup class="holamundo" title="Add New Alert" :active.sync="AlertPopup">
      <div class="p-6 pt-0">
        <div>
          <vs-radio v-model="selected" vs-value="student">Students</vs-radio>
          &nbsp;
          <vs-radio v-model="selected" vs-value="manager">Staff</vs-radio>
        </div>
        <label class="vs-select--label w-full">Select Location *</label>
        <label
          class="ml-5 vs-select--label"
          @click="allLocation"
          style="float: right"
          >Select All</label
        >
        <v-select
          label="name"
          multiple
          @input="getProgram()"
          :closeOnSelect="true"
          v-model="dataLocation"
          :options="locations"
        /><br />
        <label class="vs-select--label w-full">Select Program *</label
        ><label
          class="vs-select--label"
          @click="allProgram"
          style="float: right"
          >Select All</label
        >
        <v-select
          label="name"
          multiple
          @input="getStudent()"
          :closeOnSelect="true"
          v-model="dataProgram"
          :options="programs"
        /><br />
        <label class="vs-select--label w-full">Message *</label>
        <vs-textarea
          label=""
          id="textid"
          v-model="dataMessage"
          name="message"
          v-validate="'required'"
        />
        <div class="vx-row mb-1">
          <div class="vx-col w-full">
            <vs-checkbox
              class="inline-flex"
              :disabled="select"
              v-model="dataSms"
              >SMS</vs-checkbox
            >
            <vs-checkbox
              class="inline-flex"
              :disabled="select"
              v-model="dataInstant"
              >Instant Message</vs-checkbox
            >
          <span v-if="dataInstant"
            :id="'div-with-alert'"
            class="vs-con-loading__container inline-flex"
            :ref="'div-with-alert'"
          >
            <input
              type="file"
              multiple
              class="hidden"
              ref="AlertUpdatefileInput"
              @change="AlertUploadFile"
              accept="*" />
            <feather-icon
              icon="PaperclipIcon"
              class="ml-1"
              @click="$refs.AlertUpdatefileInput.click()"
            ></feather-icon
          ></span>
          </div>
        </div>
          <div>
          <span v-if="AlertUplodedfiles.length>0">
          <span v-for="(file, index) in AlertUplodedfiles" :key="index" >
            <vs-chip
              @click="AlertRemovefile(index)"
              closable
              class="leading-none font-medium"
              >{{ file.orignal }}</vs-chip>
          </span>
          <br /><br />
          </span>
           <span v-if="AlertlargeFile.length > 0" class="text-danger text-sm">
           <p>Large Files</p>  
          <span v-for="(file, i) in AlertlargeFile" :key="i" >
             <vs-chip class="leading-none font-medium">{{ file }}</vs-chip>
          </span>
          <br /><br />
          </span>
        </div>
        <div v-if="students.length > 0" class="ml-2 mb-2">
           <input type="checkbox"  @change="SelectAllChip()"  class="inline-flex" v-model="chipcheck"/>
           <small class="ml-1">Select All</small>
        </div>

        <span v-for="(student, index) in students" :key="index">
          <vs-chip>
            <input type="checkbox" class="mr-5" v-model="student.instant" />
            <vs-avatar v-if="student.image" :src="img_cdn + student.image" />
            <vs-avatar v-else />
            {{ student.fname }} {{ student.lname }}
          </vs-chip>
        </span>
        <!-- <div v-for="(student,index) in students" :key="index" class="inline-flex">
       <div class="inline-flex mr-10">
         
      <input type="checkbox" v-model="student.instant" class="font-medium mt-3 mr-2"/>    
       <span v-if="student.image" class="mr-2"><vs-avatar class="m-0" :src="img_cdn+student.image"  size="35px" /></span>
        <span v-else class="mr-2"><vs-avatar class="m-0" :src="student.image"  size="35px" /></span>
        <p class="font-medium mt-2">{{ student.fname }} {{ student.lname }}</p>

        </div>   -->
        <!-- <vs-row>
  <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
    <div v-if="student.image" class="mr-2"><vs-avatar class="m-0" :src="img_cdn+student.image"  size="35px" /></div>
        <div v-else class="mr-2"><vs-avatar class="m-0" :src="student.image"  size="35px" /></div>
        <p class="font-medium mt-2">{{ student.fname }} {{ student.lname }}</p>
  </vs-col>
   <vs-col  vs-justify="left" vs-align="left" vs-w="8">
     <span v-for="(user,indexx) in student.users" :key="indexx" >
          <vs-chip>
          <input type="checkbox" v-model="user.check" v-if="user.active">
          <input type="checkbox" v-model="user.check" disabled  v-else >
          <p class="ml-2">{{user.fname}} {{user.lname}}</p>
               </vs-chip> 
         </span>
  </vs-col>
</vs-row> -->
        <!-- </div> -->

        <!-- <vs-row v-if="student.users.length > 0">
        <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4" class="ml-0">
        <div class="flex">
        <div v-if="student.image" class="mr-2"><vs-avatar class="m-0" :src="img_cdn+student.image"  size="35px" /></div>
        <div v-else class="mr-2"><vs-avatar class="m-0" :src="student.image"  size="35px" /></div>
        <p class="font-medium mt-2">{{ student.fname }} {{ student.lname }}</p>
          </div>
         </vs-col>
          <span v-for="(user,indexx) in student.users" :key="indexx" vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
          <vs-chip>
          <input type="checkbox" v-model="user.check">
          <p class="ml-2">{{user.fname}} {{user.lname}}</p>
               </vs-chip> 
         </span>
        </vs-row> -->
        <div slot="footer" style="float: right" class="mt-5">
          <vs-button
            class="vs-con-loading__container"
            ref="loadableButton"
            id="button-with-loading"
            @click="submitData"
            :disabled="!isFormValid"
            >{{ $t("student.add.btn_submit") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
    {{ closepopup }}
  </div>
</template>

<script>
import 'flatpickr/dist/flatpickr.css'
import AlertViewSidebar from './AlertViewSidebar.vue'
import {
  ALL_ALERT,
  CREATE_ALERT,
  UPDATE_ANNOUNCEMENT,
  DROPDOWN_ALL_LOCATIONS,
  GET_PROGRAM_BY_LOCATIONS,
  GET_STUDENT_BY_PROGRAMS,
  MANAGER_LOCATION,
  GET_TEACHER_PROGRAM_BY_LOCATIONS,
  USER_LOCATION,
  CREATE_ALERT_PROGRAM
} from '@/graphql'
import moment from 'moment'
import vSelect from 'vue-select'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  dirName: process.env.VUE_APP_AWS_DIREC,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config)

export default {
  components: {
    AlertViewSidebar,
    'v-select': vSelect
  },
  filters: {
    formatDates (value) {
      if (value) {
        return moment.utc(value).local().format('MM/DD/YYYY h:mm A');
      }
    }
  },
  data () {
    return {
      data: [],
      selected: 'student',
      itemsPerPage: 10,
      isMounted: false,
      activeLoading: false,
      addNewDataSidebar: false,
      sidebarData: {},
      DeleteItem: '',
      popupView: false,
      popupStudentView: false,
      popupProgramView: false,
      MsgpopupView: false,
      MsgView: '',
      UserView: '',
      ProgramView: '',
      StudentView: '',
      AlertPopup: false,
      dataMessage: '',
      locations: [],
      programs: [],
      students: [],
      dataLocation: '',
      dataProgram: '',
      btnDisable: true,
      dataInstant: false,
      dataSms: false,
      chipcheck: true,
      meRole: '',
      meID: '',
      AlertlargeFile:[],
      AlertUplodedfiles:[],
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedCamUsers () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.data.length
    },
    isFormValid () {
      return (
        !this.errors.any() &&
        this.dataMessage &&
        this.dataLocation &&
        this.dataProgram &&
        this.students &&
        this.btnDisable &&
        (this.dataInstant || this.dataSms)
      )
    },
    select () {
      const select = this.selected
      this.dataLocation = []
      this.dataProgram = []
      this.students = []
      if (select === 'manager') {
        this.dataSms = false
        this.dataInstant = true
        return true
      } else {
        this.dataSms = false
        this.dataInstant = false
      }
    },
    closepopup () {
      if (!this.AlertPopup) {
        if (this.meRole == 'teacher') {
          this.dataMessage = ''
          this.dataProgram = ''
          this.dataId = null
          this.students = []
          this.btnDisable = true
          this.dataInstant = false
          this.dataSms = false
          this.chipcheck = true
          this.AlertlargeFile = []
          this.AlertUplodedfiles = []
        } else {
          this.initValues()
        }
      }
    }
  },
  methods: {
    AlertRemovefile (file) {
      this.AlertUplodedfiles.splice(file, 1)
    },
    openLoadingfile () {
      this.$vs.loading({
        type: 'sound',
        container: '#div-with-alert',
        scale: 0.6
      })
    },
    AlertUploadFile () {
      const largeFile = []
      for (let i = 0; i < this.$refs.AlertUpdatefileInput.files.length; i++) {
        const limit = 1024 * 1024 * 2048
        if (this.$refs.AlertUpdatefileInput.files[i].size > limit) {
          largeFile.push(this.$refs.AlertUpdatefileInput.files[i].name)
        } else {
          const file = this.$refs.AlertUpdatefileInput.files[i]
          const orignal_name = this.$refs.AlertUpdatefileInput.files[i].name
          const name = Math.random().toString().slice(2)
          this.openLoadingfile()
          S3Client.uploadFile(file, name)
            .then((response) => {
              console.log(response)
              this.$vs.loading.close('#div-with-alert > .con-vs-loading')
              this.SaveAlertFile(response, orignal_name)
            })
            .catch((err) => console.error(err))
        }
      }
      this.AlertlargeFile = largeFile
    },
    SaveAlertFile (response, orignal_name) {
      if (response) {
        this.AlertUplodedfiles.push({
          orignal: orignal_name,
          new: response.key,
          link: response.location
        })
      }
    },
    SelectAllChip () {
      if (this.chipcheck) {
        for (let index = 0; index < this.students.length; index++) {
          this.students[index].instant = true
        }
      } else {
        for (let index = 0; index < this.students.length; index++) {
          this.students[index].instant = false
        }
      }
    },
    allLocation () {
      if (this.dataLocation.length === this.locations.length) {
        this.dataLocation = []
      } else {
        this.dataLocation = this.locations
      }
      this.getProgram()
    },
    allProgram () {
      if (this.dataProgram.length === this.programs.length) {
        this.dataProgram = []
      } else {
        this.dataProgram = this.programs
      }
      this.getStudent()
    },
    getProgram () {
      this.students = []
      this.programs = []
      this.dataProgram = ''
      const locations = []
      if (this.dataLocation.length > 0) {
        for (let i = 0; i < this.dataLocation.length; i++) {
          locations.push(this.dataLocation[i].id)
        }
        if (this.meRole == 'teacher') {
          this.$apollo
            .mutate({
              mutation: GET_TEACHER_PROGRAM_BY_LOCATIONS,
              variables: {
                teacher_id: this.meID,
                location_id: locations
              }
            })
            .then((response) => {
              if (response) {
                for (
                  let index = 0;
                  index < response.data.teacher_locations_programs.length;
                  index++
                ) {
                  this.programs.push(
                    response.data.teacher_locations_programs[index]
                  )
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.$apollo
            .mutate({
              mutation: GET_PROGRAM_BY_LOCATIONS,
              variables: {
                location_id: locations
              }
            })
            .then((response) => {
              if (response) {
                for (
                  let index = 0;
                  index < response.data.locations_programs.length;
                  index++
                ) {
                  this.programs.push(response.data.locations_programs[index])
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    getStudent () {
      if (this.selected === 'student') {
        this.dataSms = false
        this.dataInstant = false
        this.students = []
        const program = []
        if (this.dataProgram.length > 0) {
          for (let i = 0; i < this.dataProgram.length; i++) {
            program.push(this.dataProgram[i].id)
          }
          this.$apollo
            .mutate({
              mutation: GET_STUDENT_BY_PROGRAMS,
              variables: {
                program_id: program
              }
            })
            .then((response) => {
              if (response) {
                const filterUser = []
                const listStudent = response.data.programsStudent
                // this.students = listStudent
                if (listStudent.length > 0) {
                  for (let i = 0; i < listStudent.length; i++) {
                    listStudent[i].instant = true
                    if (listStudent[i].users.length > 0) {
                      const listusers = []
                      for (let j = 0; j < listStudent[i].users.length; j++) {
                        const user = listStudent[i].users[j]
                        if (user.phone_verified && user.pivot.alert) {
                          user.check = true
                          if (filterUser.indexOf(user.id) == -1) {
                            user.active = true
                            filterUser.push(user.id)
                            listusers.push(user)
                          } else {
                            user.active = false
                            listusers.push(user)
                          }
                        }
                      }

                      listStudent[i].users = listusers
                    }
                    if (listStudent[i].users.length > 0) {
                      this.students.push(listStudent[i])
                    }
                  }
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    ViewMessage (msg) {
      this.MsgView = msg
      this.MsgpopupView = true
    },
    Viewdata (user) {
      this.UserView = user
      this.popupView = true
    },
    ViewStudentdata (student) {
      this.StudentView = student
      this.popupStudentView = true
    },
    ViewProgramdata (student) {
      this.ProgramView = student
      this.popupProgramView = true
    },
    getdata (value) {
      if (value) {
        this.getAlert()
      }
    },
    StatusSuccess (msg) {
      this.getAlert()
      this.$vs.notify({
        title: 'Alert',
        text: msg,
        color: 'success',
        position: 'top-right'
      })
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    addNewData () {
      this.AlertPopup = true
      // console.log(this.$refs['btn'])
      // this.$refs['btn'].$el.classList.add('isActive');
      // this.$refs['btn'].$el.style.opacity=1
      // this.$refs['btn'].$el.click()

      // this.$refs['btn2'].$el.click()
      // this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    closeAlertPopup () {
      this.AlertPopup = false
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    openLoadingContained () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: this.$refs.loadableButton.$el,
        scale: 0.45
      })
    },
    submitData () {
      this.btnDisable = false
      this.openLoadingContained()
      if (this.selected === 'student') {
        const lastusers = []
        const laststudent = []
        if (this.students.length > 0) {
          for (let i = 0; i < this.students.length; i++) {
            if (this.students[i].instant) {
              laststudent.push(this.students[i].id)
              for (let j = 0; j < this.students[i].users.length; j++) {
                if (
                  this.students[i].users[j].check &&
                  this.students[i].users[j].pivot.alert
                ) {
                  lastusers.push(this.students[i].users[j])
                }
              }
            }
          }
        }
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$apollo
              .mutate({
                mutation: CREATE_ALERT,
                variables: {
                  msg: this.dataMessage,
                  instant: this.dataInstant,
                  sms: this.dataSms,
                  users: lastusers,
                  students: laststudent,
                  files: this.AlertUplodedfiles
                }
              })
              .then((response) => {
                if (response) {
                  this.$vs.loading.close(this.$refs.loadableButton.$el)
                  this.btnDisable = true
                  if (response.data.createAlert.status == 'Success') {
                    this.StatusSuccess(response.data.createAlert.message)
                    this.initValues()
                    this.getAlert()
                  }
                }
                this.closeAlertPopup()
              })
              .catch((error) => {
                this.$vs.loading.close(this.$refs.loadableButton.$el)
                this.btnDisable = true
              })
          }
        })
      }
      if (this.selected === 'manager') {
        const lastprograms = []
        for (let index = 0; index < this.dataProgram.length; index++) {
          lastprograms.push(this.dataProgram[index].id)
        }
        this.$apollo
          .mutate({
            mutation: CREATE_ALERT_PROGRAM,
            variables: {
              msg: this.dataMessage,
              programs: lastprograms,
              files: this.AlertUplodedfiles
            }
          })
          .then((response) => {
            if (response) {
              this.$vs.loading.close(this.$refs.loadableButton.$el)
              this.btnDisable = true
              if (response.data.createAlertProgram.status == 'Success') {
                this.StatusSuccess(response.data.createAlertProgram.message)
                this.initValues()
                this.getAlert()
              }
            }
            this.closeAlertPopup()
          })
          .catch((error) => {
            this.$vs.loading.close(this.$refs.loadableButton.$el)
            this.btnDisable = true
          })
      }
    },
    initValues () {
      this.dataLocation = ''
      this.dataMessage = ''
      this.dataProgram = ''
      this.dataId = null
      this.programs = []
      this.students = []
      this.btnDisable = true
      this.dataInstant = false
      this.dataSms = false
      this.chipcheck = true
      this.selected = 'student'
      this.AlertlargeFile = []
      this.AlertUplodedfiles = []
    },
    get () {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.meRole = userRole
      this.meID = userId
      this.conditionMethod(userRole,userId)
    },
    conditionMethod (role, id) {
      if (role === 'manager') {
        this.$apollo
          .mutate({
            mutation: MANAGER_LOCATION,
            variables: {
              id
            }
          })
          .then((response) => {
            this.locations = response.data.user.managerlocations
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (role === 'teacher') {
        this.$apollo
          .mutate({
            mutation: USER_LOCATION,
            variables: {
              id
            }
          })
          .then((response) => {
            this.locations = response.data.user.locations
            this.allLocation()
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.$apollo
          .mutate({
            mutation: DROPDOWN_ALL_LOCATIONS
          })
          .then((response) => {
            this.locations = response.data.dropdownlocations
          })
      }
    },
    getAlert () {
      this.$apollo
        .mutate({
          mutation: ALL_ALERT
        })
        .then((response) => {
          this.data = response.data.allAlert
          this.activeLoading = false
          this.$vs.loading.close()
        })
    }
  },
  created () {
    this.getAlert()
    this.get()
  },
  mounted () {
    this.isMounted = true
  },
  beforeCreate () {
    this.activeLoading = true
    this.$vs.loading({
      type: 'sound'
    })
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn {
    float: right;
    margin-top: -50px;
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px;
    }
  }
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
